import { Fragment, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSignOut } from "react-auth-kit";
import { sendApiRequest } from "../../services/Base/base-service";
import {
  clearSecureStorage,
  clearUserContext,
  constantTimeEqualsHelper,
} from "../../services/helpers";

import ChangePasswordModal from "../Modals/ChangePasswordModal";
import UserContext from "../../store/user-context";
import {
  Form,
  FormGroup,
  Input,
  Button,
  Icon,
  Alert,
  Spinner,
} from "design-react-kit";

import classes from "../../assets/LoginForm.module.css";
import logo from "../../assets/logo.svg";
import FormsFooter from "../FormsFooter";
import { Buffer } from "buffer";

const ChangePasswordForm = () => {
  const [password, setPassword] = useState(null);
  const [repeatPassword, setRepeatPassword] = useState(null);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const locationArray = location.search.replace("?", "").split("&");

  const userContext = useContext(UserContext);

  const paramsArray = [];
  locationArray.map((item) => paramsArray.push(item.split(/=(.*)/s)));

  const navigate = useNavigate();
  const signOut = useSignOut();

  useEffect(() => {
    if (location.search === "") {
      navigate("/errors");
    }
    signOut();
    clearSecureStorage();
    clearUserContext(userContext);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function constantTimeEquals(a, b) {
    const bufA = Buffer.from(a);
    const bufB = Buffer.from(b);
    if (bufA.length !== bufB.length) return false;
    return constantTimeEqualsHelper(bufA, bufB);
  }

  const confirmChangePasswordHandler = (e) => {
    e.preventDefault();
    signOut();
    clearSecureStorage();
    clearUserContext(userContext);
    setIsLoading(true);

    if (location.pathname === "/changePassword") {
      let token = "";
      let userId = "";
      let activationType = "";

      paramsArray.forEach((item) => {
        if (item[0] === "token") {
          token = item[1];
        } else if (item[0] === "userId") {
          userId = item[1];
        } else if (item[0] === "activationType") {
          activationType = item[1];
        }
      });

      if (constantTimeEquals(password, repeatPassword)) {
        sendApiRequest(
          "Activation/SelfActivation",
          "POST",
          false,
          {
            token: token,
            userId: userId,
            password: password,
            confirmPassword: repeatPassword,
            activationType: Number(activationType),
          },
          null,
          null,
          null,
          null
        ).then((response) => {
          if (response !== undefined) {
            if (response.errors !== null) {
              setIsLoading(false);
              setError(response.errors);
            } else {
              setIsLoading(false);
              openModalHandler();
            }
          }
        });
      } else {
        setIsLoading(false);
        setError(["La password e la password di conferma non corrispondono!"]);
      }
    } else if (location.pathname === "/ChangePasswordSelf") {
      setIsLoading(true);

      let token = "";
      let email = "";
      let changeType = "";

      paramsArray.forEach((item) => {
        if (item[0] === "token") {
          token = item[1];
        } else if (item[0] === "email") {
          email = item[1];
        } else if (item[0] === "changeType") {
          changeType = item[1];
        }
      });

      if (constantTimeEquals(password, repeatPassword)) {
        sendApiRequest(
          "Password/ChangePasswordSelf",
          "POST",
          false,
          {
            token: token,
            userEmail: email,
            password: password,
            confirmPassword: repeatPassword,
            changeType: Number(changeType),
          },
          null,
          null,
          null,
          null
        ).then((response) => {
          if (response !== undefined) {
            if (response.errors !== null) {
              setIsLoading(false);
              setError(response.errors);
            } else {
              setIsLoading(false);
              openModalHandler();
            }
          }
        });
      } else {
        setIsLoading(false);
        setError(["La password e la password di conferma non corrispondono!"]);
      }
    }
  };

  const toggleVisibilityHandler = (value) => {
    const input = document.getElementById(`${value}`);
    if (input.type === "password") {
      input.type = "text";
    } else {
      input.type = "password";
    }
  };

  const openModalHandler = () => {
    setModalOpen(true);
  };

  const closeModalHandler = () => {
    setModalOpen(false);
  };

  return (
    <Fragment>
      <div className={classes["login-wrapper"]}>
        <div className={classes["left-side"]}>
          <img src={logo} alt="Logo" />
        </div>
        <div className={classes["right-side"]}>
          <div className="d-flex flex-column align-items-start mx-auto">
            <h4 className="text-center mt-3">Inserisci password</h4>
          </div>
          {isLoading && (
            <p
              className="file-info-spinner"
              style={{
                height: "10px",
                position: "relative",
                marginBottom: "2rem",
                marginRight: "3rem",
              }}
            >
              <Spinner double active />
            </p>
          )}
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="mx-auto">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}
          <Form className="col-8 mr-auto ml-auto">
            <div className="form-row">
              <FormGroup className="col-sm-12 m-0 position-relative">
                <Input
                  id="password"
                  type="password"
                  label="Password"
                  placeholder="Password"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <Icon
                  icon="it-password-visible"
                  className={classes.eye}
                  onClick={(e) => toggleVisibilityHandler("password")}
                  fill="#005A9A"
                />
              </FormGroup>
            </div>
            <p className="instructions">
              <Icon
                icon="it-info-circle"
                fill="#005A9A"
                className="instructions-icon"
              />
              La password deve avere una lunghezza minima di 8 caratteri e
              contenere almeno una lettera maiuscola, una minuscola e un numero.
            </p>
            <div className="form-row mt-4">
              <FormGroup className="col-sm-12 m-0 position-relative">
                <Input
                  id="password-repeat"
                  type="password"
                  label="Conferma password"
                  placeholder="Conferma password"
                  onChange={(e) => setRepeatPassword(e.target.value)}
                />
                <Icon
                  icon="it-password-visible"
                  className={classes.eye}
                  onClick={(e) => toggleVisibilityHandler("password-repeat")}
                  fill="#005A9A"
                />
              </FormGroup>
            </div>
            <FormGroup className="col-12 mb-2 d-flex align-items-center justify-content-end">
              <Button
                color="primary"
                className="change-password-btn"
                onClick={(e) => confirmChangePasswordHandler(e)}
              >
                Conferma
              </Button>
            </FormGroup>
          </Form>
          <FormsFooter classes={classes} />
        </div>
      </div>
      <ChangePasswordModal
        modalOpen={modalOpen}
        modalCloseHandler={closeModalHandler}
      />
    </Fragment>
  );
};

export default ChangePasswordForm;
